/* choose-popup.js - Choose options window (replaces quick view) with variant pictures and bundle options */
(function () {
  var cfg = null;
  var modal = null;
  var cache = {};
  var lastFocus = null;
  var Q = String.fromCharCode(34);
  var A = String.fromCharCode(39);
  function T() { return window.theme || {}; }
  function esc(s) {
    return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(Q).join('&quot;').split(A).join('&#39;');
  }
  function money(c) {
    var cc = T().currency || T().shopCurrency || 'USD';
    try { return new Intl.NumberFormat(T().locale || undefined, { style: 'currency', currency: cc }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }
  function src(x) { return x ? (typeof x === 'string' ? x : (x.src || '')) : ''; }
  function thumb(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function parseTiers(str) {
    return (str || '').split('|').filter(Boolean).map(function (row) {
      var p = row.split('~');
      return { title: p[0] || '', qty: Math.max(1, parseInt(p[1], 10) || 1), pct: parseInt(p[2], 10) || 0, badge: p[3] || '', icon: p[4] || '', style: p[5] || 'pill', pre: p[6] === 'true' };
    });
  }
  function readCfg() {
    if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
    modal = null;
    var el = document.getElementById('choose-popup-cfg');
    if (!el || el.getAttribute('data-enable') !== 'true') { cfg = null; return; }
    cfg = {
      el: el,
      bundle: el.getAttribute('data-bundle') === 'true',
      bundleHeading: el.getAttribute('data-bundle-heading') || '',
      saveText: el.getAttribute('data-save-text') || '',
      tiers: parseTiers(el.getAttribute('data-tiers')),
      swatches: el.getAttribute('data-swatches') === 'true',
      showQty: el.getAttribute('data-qty') === 'true',
      btn: el.getAttribute('data-btn') || 'Add to cart',
      rating: el.getAttribute('data-rating') || '',
      details: el.getAttribute('data-details') === 'true',
      detailsLabel: el.getAttribute('data-details-label') || 'View full details'
    };
  }
  function ensureModal() {
    if (modal) return modal;
    var el = cfg.el;
    var css = '';
    if (el.getAttribute('data-accent')) css += '--cpop-acc:' + el.getAttribute('data-accent') + ';';
    if (el.getAttribute('data-price')) css += '--cpop-price:' + el.getAttribute('data-price') + ';';
    css += '--cpop-r:' + (parseInt(el.getAttribute('data-radius'), 10) || 16) + 'px;';
    css += '--cpop-w:' + (parseInt(el.getAttribute('data-width'), 10) || 980) + 'px;';
    css += '--cpop-btn-r:' + (el.getAttribute('data-btn-r') || '10px') + ';';
    css += 'background:rgba(0,0,0,' + ((parseInt(el.getAttribute('data-overlay'), 10) || 55) / 100) + ')';
    modal = document.createElement('div');
    modal.className = 'cpop';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.style.cssText = css;
    modal.innerHTML = `<div class='cpop__box' data-box></div>`;
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.body.appendChild(modal);
    return modal;
  }
  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var root = (T().routes && T().routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function open(handle) {
    var m = ensureModal();
    var box = m.querySelector('[data-box]');
    box.innerHTML = `<button type='button' class='cpop__close' data-close aria-label='Close'>&times;</button><p class='cpop__loading'>Loading...</p>`;
    box.onclick = function (e) { if (e.target.closest && e.target.closest('[data-close]')) close(); };
    lastFocus = document.activeElement;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    load(handle).then(function (p) { render(box, p); }).catch(function () {
      box.innerHTML = `<button type='button' class='cpop__close' data-close aria-label='Close'>&times;</button><p class='cpop__loading'>Sorry, this product could not be loaded.</p>`;
    });
  }
  function render(box, p) {
    var variants = p.variants || [];
    if (!variants.length) return;
    var optNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var many = variants.length > 1;
    var start = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var st = { sel: (start.options || []).slice(), variant: start, tier: 0, units: [], qty: 1 };
    var useB = cfg.bundle && cfg.tiers.length > 0;
    cfg.tiers.forEach(function (t, i) { if (t.pre) st.tier = i; });
    function byId(id) {
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) return variants[i]; }
      return start;
    }
    function find(sel) {
      return variants.filter(function (x) { return sel.every(function (o, i) { return x.options[i] === o; }); })[0] || null;
    }
    function resetUnits() {
      st.units = cfg.tiers.map(function (t) {
        var a = [];
        for (var j = 0; j < t.qty; j++) a.push(st.variant.id);
        return a;
      });
    }
    resetUnits();
    function imgOf(v) { return src(v.featured_image) || src(p.featured_image) || (p.images && p.images[0]) || ''; }
    function valueImg(i, val) {
      for (var k = 0; k < variants.length; k++) {
        if (variants[k].options[i] === val && variants[k].featured_image) return src(variants[k].featured_image);
      }
      return '';
    }
    function calc(t, i) {
      var base = 0;
      var cmp = 0;
      st.units[i].forEach(function (id) {
        var x = byId(id);
        base += x.price;
        cmp += (x.compare_at_price && x.compare_at_price > x.price) ? x.compare_at_price : x.price;
      });
      var total = Math.round(base * (100 - t.pct) / 100);
      return { total: total, strike: cmp > total ? cmp : 0, save: Math.max(0, cmp - total) };
    }
    function optionHtml(name, i) {
      var values = [];
      variants.forEach(function (x) { if (values.indexOf(x.options[i]) < 0) values.push(x.options[i]); });
      var imgs = cfg.swatches && i === 0 && values.every(function (val) { return !!valueImg(i, val); });
      var btns = values.map(function (val) {
        var test = st.sel.slice();
        test[i] = val;
        var m = find(test) || variants.filter(function (x) { return x.options[i] === val; })[0];
        var ok = m && m.available;
        var cls = 'cpop__val' + (imgs ? ' cpop__val--img' : '') + (st.sel[i] === val ? ' is-active' : '') + (ok ? '' : ' is-unavail');
        var inner = imgs ? `<img src='${esc(thumb(valueImg(i, val), 120))}' alt=''>` : esc(val);
        return `<button type='button' class='${cls}' data-opt='${i}' data-val='${esc(val)}' title='${esc(val)}'>${inner}</button>`;
      }).join('');
      return `<fieldset class='cpop__opt'><legend>${esc(name)}: <b>${esc(st.sel[i])}</b></legend><div class='cpop__vals'>${btns}</div></fieldset>`;
    }
    function tierHtml(t, i) {
      var c = calc(t, i);
      var on = st.tier === i;
      var units = '';
      if (on && many) {
        units = `<div class='cpop-t__units'>${st.units[i].map(function (id, j) {
          var opts = variants.map(function (x) { return `<option value='${x.id}'${x.id === id ? ' selected' : ''}${x.available ? '' : ' disabled'}>${esc(x.title)}</option>`; }).join('');
          return `<div class='cpop-u'><span>#${j + 1}</span><select data-unit='${i}:${j}'>${opts}</select></div>`;
        }).join('')}</div>`;
      }
      var save = c.save > 0 ? cfg.saveText.replace('[amount]', money(c.save)) : '';
      var off = t.pct > 0 ? `<em class='cpop-t__off'>${t.pct}% Off</em>` : '';
      var badge = (t.badge || t.icon) ? `<span class='cpop-b cpop-b--${esc(t.style)}'>${esc(t.badge)}${t.icon ? ' ' + esc(t.icon) : ''}</span>` : '';
      return `<div class='cpop-t${on ? ' is-selected' : ''}' data-tier='${i}'><span class='cpop-t__dot'></span><span class='cpop-t__main'><b>${esc(t.title)}</b>${off}${save ? `<small>${esc(save)}</small>` : ''}</span><span class='cpop-t__price'><strong>${money(c.total)}</strong>${c.strike ? `<s>${money(c.strike)}</s>` : ''}</span>${badge}${units}</div>`;
    }
    function draw() {
      var v = st.variant;
      var im = imgOf(v);
      box.querySelector('[data-media]').innerHTML = im ? `<img src='${esc(thumb(im, 900))}' alt='${esc(p.title)}'>` : '';
      var ok;
      var bundleHtml = '';
      var actions;
      if (useB) {
        ok = st.units[st.tier].every(function (id) { return byId(id).available; });
        bundleHtml = `<div class='cpop__bhead'><span>${esc(cfg.bundleHeading)}</span></div>${cfg.tiers.map(tierHtml).join('')}`;
        actions = `<div class='cpop__actions'><button type='button' class='cpop__add' data-add${ok ? '' : ' disabled'}>${esc(ok ? cfg.btn : 'Sold out')}</button></div>`;
      } else {
        ok = v.available;
        actions = `<div class='cpop__actions'>${cfg.showQty ? `<div class='cpop__qty'><button type='button' data-q='-1'>&minus;</button><input type='text' value='${st.qty}' inputmode='numeric' data-qty><button type='button' data-q='1'>+</button></div>` : ''}<button type='button' class='cpop__add' data-add${ok ? '' : ' disabled'}>${esc(ok ? cfg.btn : 'Sold out')}</button></div>`;
      }
      var rating = cfg.rating ? `<p class='cpop__rating'><b>&#9733;&#9733;&#9733;&#9733;&#9733;</b> ${esc(cfg.rating)}</p>` : '';
      var price = `<div class='cpop__price'><strong>${money(v.price)}</strong>${v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : ''}</div>`;
      var opts = many ? optNames.map(optionHtml).join('') : '';
      var link = cfg.details ? `<a class='cpop__link' href='${esc(p.url || ('/products/' + p.handle))}'>${esc(cfg.detailsLabel)}</a>` : '';
      box.querySelector('[data-info]').innerHTML = `<h2 class='cpop__title'>${esc(p.title)}</h2>${rating}${price}${opts}${bundleHtml}${actions}<p class='cpop__err' data-err hidden></p>${link}`;
    }
    function chooseOpt(i, val) {
      var test = st.sel.slice();
      test[i] = val;
      var m = find(test) || variants.filter(function (x) { return x.options[i] === val; })[0];
      if (!m) return;
      st.variant = m;
      st.sel = m.options.slice();
      resetUnits();
      draw();
    }
    function add() {
      var items = [];
      if (useB) {
        var map = {};
        st.units[st.tier].forEach(function (id) { map[id] = (map[id] || 0) + 1; });
        items = Object.keys(map).map(function (k) { return { id: parseInt(k, 10), quantity: map[k] }; });
      } else {
        items = [{ id: st.variant.id, quantity: st.qty }];
      }
      var btn = box.querySelector('[data-add]');
      var err = box.querySelector('[data-err]');
      if (btn) btn.disabled = true;
      if (err) err.hidden = true;
      fetch((T().routes && T().routes.cartAdd) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () {
          close();
          if (T().cart && T().cart.open) return T().cart.open();
          window.location.href = (T().routes && T().routes.cart) || '/cart';
        })
        .catch(function (e2) {
          if (err) { err.textContent = e2.message; err.hidden = false; }
          if (btn) btn.disabled = false;
        });
    }
    box.innerHTML = `<button type='button' class='cpop__close' data-close aria-label='Close'>&times;</button><div class='cpop__media' data-media></div><div class='cpop__info' data-info></div>`;
    box.onclick = function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-close]')) { close(); return; }
      var ob = t.closest('[data-opt]');
      if (ob) { chooseOpt(parseInt(ob.getAttribute('data-opt'), 10), ob.getAttribute('data-val')); return; }
      var tr = t.closest('[data-tier]');
      if (tr && !t.closest('select')) {
        var ti = parseInt(tr.getAttribute('data-tier'), 10);
        if (ti !== st.tier) { st.tier = ti; draw(); }
        return;
      }
      var qb = t.closest('[data-q]');
      if (qb) { st.qty = Math.max(1, st.qty + parseInt(qb.getAttribute('data-q'), 10)); draw(); return; }
      if (t.closest('[data-add]')) add();
    };
    box.onchange = function (e) {
      var s = e.target;
      if (s.matches && s.matches('[data-unit]')) {
        var parts = s.getAttribute('data-unit').split(':');
        st.units[parseInt(parts[0], 10)][parseInt(parts[1], 10)] = parseInt(s.value, 10);
        draw();
      } else if (s.matches && s.matches('[data-qty]')) {
        st.qty = Math.max(1, parseInt(s.value, 10) || 1);
        draw();
      }
    };
    draw();
  }
  document.addEventListener('click', function (e) {
    if (!cfg) return;
    var b = e.target.closest ? e.target.closest('[data-quick-view]') : null;
    if (!b) return;
    var handle = b.getAttribute('data-quick-view');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    open(handle);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', readCfg); else readCfg();
  document.addEventListener('shopify:section:load', readCfg);
})();
